import { render, staticRenderFns } from "./CandidateHold.vue?vue&type=template&id=ab84da70&lang=pug"
import script from "./CandidateHold.vue?vue&type=script&lang=js"
export * from "./CandidateHold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports